import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { ONBOARDING_API } from "./apiRoutes";

interface mutateProps {
  data: FieldValues;
  communityId: string
}

const mutateValidateBulkUploadUser = async ({ data, communityId }: mutateProps) => {
  return await axiosAuth.post(`${ONBOARDING_API(communityId)}/occupancy/validate`, data,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

const useValidateBulkUploadUserMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateValidateBulkUploadUser,
    ...queryParams,
  });

export default useValidateBulkUploadUserMutation;
